<template>
  <div class="app">
    <nut-navbar style="position: fixed;z-index: 100;left: 0;right: 0;height: 57px;line-height: 57px;text-align: center;background: var(--nut-white, #fff);
    font-weight: 700;
    font-size: 1.5rem;
    color: #333;
    -webkit-box-shadow: 0px 4px 10px 0px rgb(0 0 0 / 7%);
    box-shadow: 0 4px 10px rgb(0 0 0 / 7%);"
        @on-click-back="goBack" 
        :leftShow="true" 
        :rightShow="false"
      >{{ $t('cardPlans.orderList') }}</nut-navbar>
      <div class="content">
        <div class="middle" >
          <ul class="middle-ul" >
            <li v-for="(item,index) in orderList" :key="index" >
              <p>
                <span class="span1">{{item.orderNum}}</span>
                <span class="span4">{{item.accountMoney}} {{item.currency}}</span>
              </p>
              <p>
                <span class="span2">{{item.productName}}</span>
                <span class="span3">{{item.createTime}}</span>
              </p>
            </li>
          </ul>
        </div>
      </div>
  </div>
</template>
<script>
import {wx_internationalOrderList} from "@/api/api.js";
export default {
  props: {
    parentPullUpState: {
      default: 0
    },
    onInfiniteLoad: {
      type: Function,
      require: false
    }
  },
  data() {
    return {
      iccid:"",
      orderList:[],
      propsParams:{},
      // 分页器
      page: 1,
      pageSize: 10,
      total: 20,
      top: 0,
      pullUpState: 0, // 1:上拉加载更多, 2:加载中……, 3:我是有底线的
      isLoading: false, // 是否正在加载
      pullUpInfo: {
        moreText: '上拉加载更多',
        loadingText: '数据加载中...',
        noMoreText: '我是有底线的'
      },
      startX: 0,
      startY: 0,
      endX: 0,
      endY: 0
    };
  },
  computed: {},
  methods: {
    // 后退到上一页
    goBack(){
      this.$router.go(-1);
    },
    // 获取套餐
    getMeal(){
      if(!this.isLoading){
        this.isLoading = true;
        if(this.orderList.length > this.total){
          return;
        }
        this.$toast.loading('Loading...',{
          duration:200,
          coverColor: "rgba(0,0,0,0.5)",
          closeOnClickOverlay: true,
          loadingRotate:true
        });
        let params = {
          model: {
            iccid:this.$route.query.iccid,
          },
          page: this.page,
          pageSize: this.pageSize
        };
        wx_internationalOrderList(params).then(res => {
          if(res.data.code == 200){
            this.orderList = this.orderList.concat(res.data.data.records);
            this.total = res.data.data.total;
            this.page = this.page + 1;
          } else {
            this.$toast.fail(res.data.message);
          }
        })
      }

    },
    /**
     * 触摸开始，手指点击屏幕时
     * @param {object} e Touch 对象包含的属性
     */
    touchStart (e) {
      this.startX = e.touches[0].pageX
      this.startY = e.touches[0].pageY
    },

    /**
     * 接触点改变，滑动时
     * @param {object} e Touch 对象包含的属性
     */
    touchMove (e) {
      this.endX = e.changedTouches[0].pageX
      this.endY = e.changedTouches[0].pageY
      let direction = this.getSlideDirection(this.startX, this.startY, this.endX, this.endY)
      switch (direction) {
        case 0:
          // console.log('没滑动')
          break
        case 1:
          // console.log('向上')
          this.scrollToTheEnd()
          break
        case 2:
          // console.log('向下')
          break
        case 3:
          // console.log('向左')
          break
        case 4:
          // console.log('向右')
          break
        default:
      }
    },

    /**
     * 触摸结束，手指离开屏幕时
     * @param {object} e Touch 对象包含的属性
     */
    touchend (e) {
      this.isLoading = false
    },

    /**
     * 判断滚动条是否到底
     */
    scrollToTheEnd () {
      let innerHeight = document.querySelector('.load-moudle').clientHeight
      // 变量scrollTop是滚动条滚动时，距离顶部的距离
      let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
      // 变量scrollHeight是滚动条的总高度
      let scrollHeight = document.documentElement.clientHeight || document.body.scrollHeight
      // 滚动条到底部的条件
      if (scrollTop + scrollHeight >= innerHeight) {
        if (this.pullUpState !== 3 && !this.isLoading) {
          this.infiniteLoad()
        }
        // console.log('距顶部' + scrollTop + '滚动条总高度' + scrollHeight + '内容高度' + innerHeight)
        this.getMeal();
      }
    },

    /**
     * 上拉加载数据
     */
    infiniteLoad () {
      if (this.pullUpState !== 0) {
        this.pullUpState = 2
        this.isLoading = true
        this.onInfiniteLoad(this.infiniteLoadDone)
      }
    },

    /**
     * 加载数据完成
     */
    infiniteLoadDone () {
      this.pullUpState = 1
    },

    /**
     * 返回角度
     */
    getSlideAngle (dx, dy) {
      return Math.atan2(dy, dx) * 180 / Math.PI
    },

    /**
     * 根据起点和终点返回方向 1：向上，2：向下，3：向左，4：向右,0：未滑动
     * @param {number} startX X轴开始位置
     * @param {number} startY X轴结束位置
     * @param {number} endX Y轴开始位置
     * @param {number} endY Y轴结束位置
     */
    getSlideDirection (startX, startY, endX, endY) {
      let dy = startY - endY
      let dx = endX - startX
      let result = 0
      // 如果滑动距离太短
      if (Math.abs(dx) < 2 && Math.abs(dy) < 2) {
        return result
      }
      let angle = this.getSlideAngle(dx, dy)
      if (angle >= -45 && angle < 45) {
        result = 4
      } else if (angle >= 45 && angle < 135) {
        result = 1
      } else if (angle >= -135 && angle < -45) {
        result = 2
      } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
        result = 3
      }
      return result
    }
  },
  watch: {
    parentPullUpState (curVal, oldVal) {
      this.pullUpState = curVal
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
  },
  created() {
    this.$i18n.locale = this.language;
  },
  mounted() {
    this.getMeal();
  },
};
</script>
<style scoped lang="less">
.app{
    font-size: 14px;
    font-family: Avenir, Helvetica, Arial, sans-serif, 'Microsoft YaHei','PingFangSC-Regular','Roboto';
    background: #fff;
    height: 100%;
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;

    /deep/ .nut-title{
      font-weight: 700;
    }
    .content{
      min-height: 100vh;
      background: #f7f8fa;
      overflow-x: hidden;
      overflow-y: auto;
      padding: 57px 17px 15px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      .middle{
      width: 100%;
      padding-bottom: 75px;
      .middle-ul{
        width: 100%;
        padding-bottom: 8px;
        box-sizing: border-box;
        li{
          width: 95%;
          margin: 0 auto;
          margin-top: 20px;
          border: 1px solid #0186D3;
          border-radius: 8px;
          position: relative;
          .recommend {
            width: 40px;
            height: 40px;
            position: absolute;
            left: 0;
            top: 0;
            background-size: 110%;
          }
          p{
            padding: 10px;
            display: flex;
            justify-content: space-between;
            .span1{
              font-size: 16px;
              font-weight: 700;
            }
            .span4{
              font-size: 16px;
              color:#0186D3;
            }
            .span2{
              display: inline-block;
              width: 65%;
            }

          }
        }
      }
    }
    }
}
</style>

